import { type MantineSize } from '@mantine/core';

export const PAGE_HEADER_HEIGHT = 64;

export const NAVBAR_HEIGHT = 50;
export const BANNER_HEIGHT = 35;

export const FOOTER_HEIGHT = 80;
export const FOOTER_MARGIN: MantineSize = 'lg';

export const PAGE_CONTENT_WIDTH = 900;
export const PAGE_CONTENT_MAX_WIDTH_LARGE = 1600;
export const PAGE_MIN_CONTENT_WIDTH = 600;

export const SIDEBAR_DEFAULT_WIDTH = 400;
export const SIDEBAR_MIN_WIDTH = 300;

export const SIDEBAR_RESIZE_HANDLE_WIDTH = 6;
